const state = {
    errorData: {
        status: '',
        msg: ''
    }
}

const getters = {
    getError(state: any) {
        const returnErrorData = state.errorData;
        return returnErrorData;
    },
}

const actions = {
    // incActionCounter(store: any, payload: any){
    //     // Mutationsへ
    //     store.commit('incrementMutateCounter', payload)
    // },
    initError(store: any) {
        return new Promise((resolve) => {
            store.commit('setError', {status: null, msg: null});
            resolve(true);
        });
    },
    setError(store: any, payload: {status: string|null; msg: string|null;}) {
        return new Promise((resolve) => {
            store.commit('setError', payload);
            resolve(true);
        });
    },
}

const mutations = {
    setError(state: any, payload: {status: string|null; msg: string|null;}) {
        state.errorData = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
